import React from 'react';
import { Layout } from './components/Layout';
import { Hero } from './components/Hero';
import { WhyNoronha } from './components/Features';
import { IslandGallery } from './components/IslandGallery';
import { ExperienceIncludes } from './components/ExperienceIncludes';
import { Reservas } from './components/Reservas';
import { OrganizadoPor } from './components/OrganizadoPor';
import { Testimonials } from './components/Testimonials';
import { FaqNoronha } from './components/FaqNoronha';
import { FinalCTANoronha } from './components/FinalCTANoronha';
export function App() {
  return <Layout data-id="element-0">
      <Hero data-id="element-1" />
      <WhyNoronha data-id="element-2" />
      <IslandGallery data-id="element-3" />
      <ExperienceIncludes data-id="element-4" />
      <Reservas data-id="element-5" />
      <OrganizadoPor data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FaqNoronha data-id="element-8" />
      <FinalCTANoronha data-id="element-9" />
    </Layout>;
}